import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OnDestroyComponent } from '@app/shared/components/on-destroy/on-destroy.component';
import { PropertiesService } from '@app/shared/services/properties/properties.service';
import { FetchPropertiesApiResponse } from '@app/modules/settings/services/active-properties/active-properties.service';
import { PropertyCalendarReferrerService } from '../../services/property-calendar-referrer.service';
import { takeUntil } from 'rxjs';

const PROPERTY_LIMIT = 25;

@Component({
  selector: 'sbnb-calendar-landing',
  templateUrl: './calendar-landing.component.html',
  styleUrls: ['./calendar-landing.component.scss'],
})
export class CalendarLandingComponent extends OnDestroyComponent implements OnInit {
  loading = true;
  data: FetchPropertiesApiResponse;

  constructor(
    private propertiesService: PropertiesService,
    private router: Router,
    private propertyCalendarReferrerService: PropertyCalendarReferrerService
  ) {
    super();
  }

  ngOnInit(): void {
    this.propertiesService
      .getProperties({
        filterCriteria: [],
        offset: 0,
        limit: PROPERTY_LIMIT,
        paginate: true,
        includes: ['children', 'calendar_restricted', 'can_manage_availability'],
      })
      .pipe(takeUntil(this.destroyed$))
      .subscribe((res) => {
        if (res && res.data) {
          if (res.data.length === 1 && res.data[0].children.length === 0) {
            this.propertyCalendarReferrerService.setReferrer('calendar');
            this.router.navigate(['/calendar/property', res.data[0].id], {
              state: { property: res.data[0] },
            });
            return;
          } else {
            this.loading = false;
            this.data = res;
          }
        }
      });
  }
}
